<template>
    <admin-layout>

        <app-content-pane class="ml-3">

            <template #title>
                <div class="top">
                    <div class="px-4 pt-3">
                        <h1>Organizations</h1>
                        <nav>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">Organizations</li>
                            </ol>
                        </nav>
                    </div>
                    <div class="actions px-4 pt-3">
                        <div class="form-group">
                            <inertia-link :href="route('organization.create', {...global_url_params})"
                                          class="btn btn-primary d-flex align-items-center justify-content-center">
                                <img src="/images/icons/plus-circle-solid-light.svg" class="mr-2" alt="">
                                Create New Organization
                            </inertia-link>
                        </div>
                    </div>
                </div>

            </template>

            <div class="organizations">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>
                            <input type="text" class="form-control" placeholder="search" v-model="filters.q">
                        </th>
                        <th>
                            Users
                        </th>
                        <th>
                            Projects
                        </th>
                        <th>
                            Registered On
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="org in orgs" :key="org.id">
                        <td>
                            <div class="font-weight-bold h6 mb-0">
                                {{ org.name }}
                                <span class="badge" :class="{
                                    'badge-dark': org.account_type === 'free',
                                    'badge-warning': (org.trial_expire_at && org.trial_expires_in >= 0 && org.account_type === 'paid'),
                                    'badge-danger': (org.trial_expire_at && org.trial_expires_in < 0 && org.account_type === 'paid'),
                                    'badge-primary': (! org.trial_expire_at && org.account_type === 'paid'),
                                }">
                                    <template v-if="org.trial_expire_at">
                                        {{ org.trial_expires_in >= 0 ? `trial (${org.trial_expires_in} days)` : 'trial:expired' }}
                                    </template>
                                    <template v-else>
                                        {{ org.account_type }}{{ org.account_type !== org.account_type ? ':org' : '' }}
                                    </template>
                                </span>

                            </div>

                            <div class="mb-1">
                                {{ org.meta?.address }}
                            </div>

                            <div class="actions">
                                <inertia-link :href="route('organization.edit', {organization: org.id, ...global_url_params})"
                                              class="btn btn-link btn-sm px-1">Edit</inertia-link>
                                <inertia-link :href="route('report.org', {organization: org.id, ...global_url_params})"
                                              class="btn btn-link text-success btn-sm px-1">View Report</inertia-link>
                            </div>
                        </td>
                        <td>
                            <inertia-link :href="route('usr.index', {organization_id: org.id, ...global_url_params})"
                                          title="View Users">{{ org.user_count }}</inertia-link>
                        </td>
                        <td>
                            <inertia-link :href="route('project.index', {organization_id: org.id, ...global_url_params})"
                                          title="View Projects">{{ org.project_count }}</inertia-link>
                        </td>
                        <td>{{ dateFormat( org.created_at ) }}</td>
                    </tr>
                    </tbody>
                    <caption v-if="!orgs || !orgs.length" class="px-3">
                        <div class="alert alert-danger mb-0 mt-5">
                            Sorry no users found. Please try with different search criteria.
                        </div>
                    </caption>
                </table>

                <div class="mx-3 mt-3 pb-4">
                    <pagination :links="organizations.links"></pagination>
                </div>

            </div>
        </app-content-pane>

    </admin-layout>
</template>

<script>
import Pagination from "@/Components/Common/Pagination";
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
export default {
    name: "Index",
    components: {AppContentPane, AdminLayout, Pagination},
    props: ['organizations', 'pageFilters'],

    data(){
        return {

            is_ready: false,

            refreshDebounced: _.debounce(() => this.refresh(1), 500),

            filters: {
                q: '',
            }
        }
    },


    computed: {
        orgs(){
            return this.organizations?.data;
        },
    },


    watch: {
        filters: {
            deep: true,
            handler(){
                if( !this.is_ready ) return;
                this.refreshDebounced();
            }
        }
    },

    methods: {
        dateFormat(date_str){
            const d = new Date(date_str);
            return d.toLocaleString('en-US');
        },

        refresh(page = false){
            this.$inertia.reload({data: {...this.filters, page: page ? page : this.organizations.current_page}});
        },
    },


    mounted() {
        this.filters.q = this.pageFilters.q;
        this.setTitle( 'Organizations' );
        this.$nextTick(() => this.is_ready = true);
    }

}
</script>

<style lang="scss" scoped>
.top{
    display: flex;
    align-items: center;

    .actions{
        margin-left: auto;
        display: flex;
    }
}


.organizations{
    .actions{
        opacity: 0;
        transition: opacity .3s;
    }

    tr:hover{
        .actions{
            opacity: 1;
        }
    }
}

.table{
    thead{
        th, td{
            vertical-align: middle;
        }
    }
}

</style>
